import { slugify } from '@techmely/utils'

export function normalizeHeadingMdPreview() {
  const headings = document.querySelectorAll(
    '#content h1, #content h2, #content h3, #content h4, #content h5',
  )
  headings.forEach((head) => {
    if (head.id) {
      head.id = slugify(head.id)
    }
  })
}
